export const categories = [
    {
        id:1,
        title:"Advancing Agriculture.",
        img:"https://images.pexels.com/photos/2886937/pexels-photo-2886937.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    },
    {
        id:2,
        title:"Making the harvest bigger.",
        img:"https://cdn.hswstatic.com/gif/Irrigation.jpg"
    },
    {
        id:3,
        title:"Getting resources closer to you.",
        img:"https://indepthdrilling.co.ke/img/neww2.jpg"
    },
    {
        id:4,
        title:"Ensuring every connection is secured.",
        img:"https://images.pexels.com/photos/9389356/pexels-photo-9389356.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    }

]

export const services = [
    {
        id:1,
        title:"BoreHole Drilling",
        images:[
            {img:"https://mintvillas.co.ke/wp-content/uploads/2022/11/building-activity-on-contruction-site-2021-08-28-04-35-46-utc-scaled.jpg"},
            {img:"https://biz-file.com/c/1802/429210-700x364.jpg?2"},
            {img:"https://rekord.co.za/wp-content/uploads/sites/85/2022/12/old-water-pump-1128_06580_tn.jpg"},
            {img:"https://grekkon-eldoret.co.ke/wp-content/uploads/2019/11/grekkon-borehole-in-kenya-site-14.jpg"},
            {img:"https://images.squarespace-cdn.com/content/v1/56fc816327d4bd42c23da52c/1547496840881-BLJK6N4TWZGQU8P8YZ3N/Well+Drilling+for+Water+Access%2C+Samburu+Kenya+Africa?format=1000w"},
            {img:"https://njuca.co.ke/wp-content/uploads/2019/08/BOREHOLE-DRILLING-SERVIVES-IN-KENYA.jpg"},
        ],
        points:[
            "Committment to provide exceptional service, high-quality results, and meeting all our clients' needs while delivering value for their investment.",
            "Adhering to safety measures to prevent accidents and ensure the well-being of our workers and clients.",
            "Extracting water or mineral samples from boreholes and providing you with accurate data for your projects.",
            "Carefully implimenting the borehole lining process to prevent contamination and ensure stability,making sure the borehole is durable and reliable ",
            "Employing precise drilling techniques and state-of-the-art equipment to reach the desired depth quickly and efficiently."
        ]
    },
    {
        id:2,
        title:"General Plumping",
        images:[
            {img:"https://www.thespruce.com/thmb/OFjhUBWe_EsQzkVrBfvGsHS_Mrs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Basic-types-of-plumbing-pipes-1822487_color-42e8122b504c4d2ea885907f6adc8739.jpg"},
            {img:"https://media.architecturaldigest.com/photos/62a788821c1c252c9ea60ad4/16:9/pass/plumbing%20tips.jpg"},
            {img:"https://www.silcoplumbing.com/wp-content/uploads/2020/05/AdobeStock_315207935-scaled.jpeg"},
            {img:"https://i.ytimg.com/vi/LkIfZADgWw4/maxresdefault.jpg"},
            {img:"https://media.istockphoto.com/id/692855504/photo/the-process-of-laying-of-engineering-and-heating-systems.jpg?s=612x612&w=0&k=20&c=os35C4IlWIot_miTBYdVvv6AAP_Gg9a7ne86jGOKVzM="},
            {img:"https://thumbs.dreamstime.com/b/joint-plastic-pipes-faucet-water-supply-farm-irrigation-gardening-pipeline-industry-joint-pvc-plastic-pipes-199507389.jpg"},
        ],
        points:[
            "Offering a range of plumbing services for homes, farms, and businesses, including repairs, installations, and maintenance.",
            "Prioritizing preventative maintenance to ensure that your plumbing systems operate at peak performance, saving you time, money, and hassle in the long run.",
            "Providing reliable, affordable, and high-quality plumbing services that meet the needs of our clients, ensuring their satisfaction and peace of mind.",
            "From fixing leaky pipes and clogged drains to installing new fixtures and fittings, we can handle any plumbing challenge you face.",
            "Engaging experienced plumbers equipped with the latest tools and technology to ensure that we deliver efficient and effective solutions to all your plumbing needs."
        ]
    },
    {
        id:3,
        title:"Tank Elevation",
        images:[
            {img:"https://www.midlandspumps.co.za/wp-content/uploads/2015/12/Tank_and_tank_stands.jpg"},
            {img:"https://staalboer.com/wp-content/uploads/2019/08/23-2-scaled.jpg"},
            {img:"https://sc04.alicdn.com/kf/HTB1NvHKKpXXXXavXpXX760XFXXXd.png"},
            {img:"https://sc04.alicdn.com/kf/HTB1xT6xz2iSBuNkSnhJq6zDcpXai.jpg"},
            {img:"https://www.afrik21.africa/wp-content/uploads/2019/04/shutterstock_511995877-1.jpg"},
            {img:"https://www.sei.org/wp-content/uploads/2019/02/water-tanks-kenya-gettyimages-185304573.jpg"},
        ],
        points:[
            "Use high-quality materials and equipment to ensure that your tanks are securely elevated and remain stable over time.",
            "Tank elevation services that are designed to meet all regulatory standards and requirements, giving you peace of mind that your tanks are compliant and safe.",
            "Proper site survey and provision of a comprehensive plan to elevate your tanks safely and efficiently",
            "Delivering quality workmanship and exceptional customer service, ensuring that your tank elevation project is completed on time, within budget, and to your satisfaction.",
            "Mechanisms for protecting elevated tanks from damage, ensuring longevity and reducing potential risks."
        ]
    },
    {
        id:4,
        title:"Irrigation",
        images:[
            {img:"https://images.nationalgeographic.org/image/upload/t_edhub_resource_key_image/v1638887084/EducationHub/photos/irrigation-canals-arizona.jpg"},
            {img:"https://grekkon-eldoret.co.ke/wp-content/uploads/2020/05/Ngeria-drip-irrigation-pics-1-scaled.jpg"},
            {img:"https://www.agrivi.com/wp-content/uploads/2017/11/wepik-2022513-9459.jpg"},
            {img:"https://agrilifeextension.tamu.edu/wp-content/uploads/2022/06/sprinkler.jpeg"},
            {img:"https://westafricanagri.com/wp-content/uploads/2020/06/Irrirgating.jpg"},
            {img:"https://i.ytimg.com/vi/amrCMakolKA/hqdefault.jpg"},
        ],
        points:[
            "specialize in providing irrigation solutions for farms, businesses, and residential properties of all sizes.",
            "Designing and installation of custom irrigation systems tailored to meet your specific needs and maximize water efficiency.",
            "Offering preventative maintenance and repair services to ensure that your irrigation system remains in top condition and provides reliable service throughout the year.",
            "Focusing on delivering high-quality, cost-effective irrigation solutions that meet your needs and exceed your expectations.",
            "Using the latest technology and techniques to ensure that your irrigation system operates at peak performance, saving you time, water, and money."
        ]
    },
    {
        id:5,
        title:"DamLiners",
        images:[
            {img:"https://www.elgonkenya.com/wp-content/uploads/2020/04/Damliners.jpg"},
            {img:"https://drtarps.com.au/wp-content/gallery/Dam-%26-Pond-Liners/dam-liners-29.jpg"},
            {img:"https://i0.wp.com/weisengineering.com/wp-content/uploads/2020/08/damliner-in-Uganda.jpg"},
            {img:"https://www.damliners.co.ke/images/banner1.png"},
            {img:"https://grekkon.com/wp-content/uploads/2019/10/grekkon-dam-liners-02.jpg"},
            {img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRE4a3E459CXvFStolR7lnv4GAZPNKk3T_nNA&usqp=CAU"},
        ],
        points:[
            "Providing exceptional service, high-quality workmanship, and cost-effective solutions that meet your needs and exceed your expectations.",
            "Use of only the best materials and techniques to ensure that your damliner is durable, reliable, and long-lasting.",
            "Installation of high-quality damliners, which are crucial for preventing water leakage and protecting the integrity of your dam.",
            "Our damliner installation process follows strict quality standards and safety measures, ensuring that your project is completed on time and within budget.",
            "Adequate site assessment and provision of customized damliner solutions that meets client's specific requirements"
        ]
    },
]
